<template>
  <div id="new-paint" v-show="is_open">
    <loading
      :active="false"
      :can-cancel="false"
      :is-full-page="false"
    />
    <div
      style="text-align:left; margin-top: 15px;"
    >
    <b-form-group
    >
    Edit main object:
 
    <div style="display:flex; margin-top:16px">
      <div style="margin-top: 10px;">
        <h4> <input-color-picker
        v-model="colorPickerEdit"

      /> </h4>

      </div>
      <div style="width:300px">
        <b-form-input
        id=""
        ref=""
        v-model="objectNameEdit"
        placeholder="Enter Object Name"
      />

      </div>
      <div style="margin-top:5px; margin-left:4px">
        <b-button 
       
            variant="gradient-danger"
            class="btn-icon rounded"
            size="sm"
        
            @click="removeObject()"
          >
            <feather-icon icon="TrashIcon" />
           
      </b-button>

      </div>
     

   
   
      
    </div>
    </b-form-group>
    <div style="justify-content:right; display: flex;">
      <b-button
        style="margin-top:10px;margin-right: 10px; display: block;"
        variant="outline-primary"
        :disabled="objectNameEdit === ''"
        @click="saveObject()"
       
      >
        Save
      </b-button>

    </div>
   

  
     
      
    </div>
  </div>
</template>
<script>
import { BButton,  BFormInput, BFormGroup, BRow, BCol } from 'bootstrap-vue'
import InputColorPicker from 'vue-native-color-picker'
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import store from '@/store/index'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import HistogramSlider from './HistogramSlider.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import { ToggleButton } from 'vue-js-toggle-button'
import Swal from 'sweetalert2'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    InputColorPicker,
    HistogramSlider,
    VueRangeSlider,
    BButton,
    Loading,
    ToggleButton
  },
  props: {
   
    actual_viewer_id: {
      required: true,
      type: Number,
      default: 0,
    },
    actual_name: {
      required: true,
      type: [String],
      default: '',
    },
    paintList: {
      required: true,
      type: [Array],
      default: '',
    },
    colorPicker: {
      required: true,
      type: [String],
      default: '',
    },
    
   
  },
  data() {
    return {
      isLoadingInfo: true,
      is_open: true,
      change_percent: false,
      newcolor: this.color,
      histogram_x: [],
      histogram_y: [],
      histogram: {},
      update: 0,
      img: '',
      isLoading: false,
      newbrightness: this.brightness,
      newcontrast: this.contrast,
      newsaturation: this.saturation,
      bgStyle: {
        backgroundColor: '#fff',
        boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
      },
      tooltipStyle: {
        backgroundColor: '#666',
        borderColor: '#666',
      },
      processStyle: {
        backgroundColor: '#999',
      },
      objectNameEdit:'',
      colorPickerEdit:'',
    
    }
  },
  created() {
    this.objectNameEdit = this.actual_name
    this.colorPickerEdit = this.colorPicker

  },


  
  methods: {
  
    
    closeParentSwal(){
      this.$swal.close()
   
    },
    async saveObject(){
      var data = []
      const { paintList, objectNameEdit, colorPickerEdit, actual_viewer_id, actual_name} = this
      data = paintList
      for(var i=0;i< data.length; i++){
        if(data[i].name == actual_name){
            data[i].name = objectNameEdit
            data[i].color = colorPickerEdit
        }
      }
      this.updatePaintList()
      console.log("We update object with id", data)
      

    },
    async updatePaintList(){
      const {actual_viewer_id } = this
  
      const {paintList} = this
      const data = { paintList: JSON.stringify(paintList)}
      axios.put(`${url}:${port}/viewer-update-paint-list/${actual_viewer_id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
          console.log("Updated", actual_viewer_id)
          
  
        }
      }).catch(err =>{
          console.log(err)
        })

    },
    async removeObject(){
    
      const { paintList, actual_name, actual_viewer_id } = this
      const dataPaint = paintList.filter(a => a.name != actual_name)
 
      const data = { paintList: JSON.stringify(dataPaint)}
      console.log("Updating", actual_viewer_id)
      axios.put(`${url}:${port}/viewer-update-paint-list/${actual_viewer_id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
          console.log("Updated", actual_viewer_id)
          this.$swal.close()
  
        }
      }).catch(err =>{
          console.log(err)
        })
    
    },
    async updatePaintList(){
      const {actual_viewer_id, paintList } = this
      const data = { paintList: JSON.stringify(paintList)}
      console.log("Updating", actual_viewer_id)
      axios.put(`${url}:${port}/viewer-update-paint-list/${actual_viewer_id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
          console.log("Updated", actual_viewer_id)
          this.$swal.close()
  
        }
      }).catch(err =>{
          console.log(err)
        })

    },
   
    
  
  },
}
</script>
<style>
.icp__input {
    height: 20px!important;
    width: 20px!important;
    margin-right:10px;
}
.swal2-actions{
 margin: 0 10px;
  /* display: none !important;  */
}
.vue-range-slider.slider-component {
  margin-left:0px!important;
}
.sat_slider{
    margin-top: -30px!important;
    margin-bottom: 20px!important;
}
#new-paint .swal2-confirm swal2-styled{
  /* display: none; */
  
}
/* .vue-js-switch .v-switch-core[data-v-25adc6c0] {
    background-color: dodgerblue !important;
} */

</style>
<style scoped>

h4{
    display: flex;
    align-items: flex-start;
}
#content{
    display: flex;
    width: 100%;
    height: 400px;
    justify-content: space-between;
}
#picture{
    width: 55%;
    display: flex;
    align-items: center;
}
#picture img{
    max-width: 90%;
    max-height: 365px
}
#histograms{
    width: 40%;
}



</style>
